/**
 * Intelligems A/B — Shop Collection mega menu
 *
 * Activates only when <body data-ig-shop-mega-menu="true"> (or "1").
 * Test A (control): leave attribute off → default dropdown menu.
 * Test B (Intelligems):
 *   document.body.setAttribute('data-ig-shop-mega-menu', 'true');
 *   window.IgShopMegaMenu.enable();
 */
(function () {
  'use strict';

  if (window.__igShopMegaMenuBooted) return;
  window.__igShopMegaMenuBooted = true;

  var CONFIG = readConfig();
  if (!CONFIG) return;
  
    var CSS = [
      '.header-wrapper { position: relative; }',
      '.ig-sc-mega__details { position: static; }',
      '.ig-sc-mega__details .header__submenu {',
      '  display: none !important; visibility: hidden !important; pointer-events: none !important;',
      '}',
      '.ig-sc-mega__details.is-active > summary > span {',
      '  text-decoration: underline; text-underline-offset: 0.3rem;',
      '}',
      '.ig-sc-mega__details.is-active > summary .icon-caret { transform: rotate(180deg); }',
      '.ig-sc-mega__backdrop {',
      '  display: none; position: fixed; left: 0; right: 0; bottom: 0; z-index: 4;',
      '  background: rgba(0,0,0,.25); pointer-events: auto;',
      '}',
      '.ig-sc-mega__backdrop.is-open { display: block; }',
      '.ig-sc-mega__body {',
      '  display: none; position: absolute; top: 100%; left: 0; right: 0; z-index: 5; width: 100%;',
      '  border-top: 1px solid rgba(18,18,18,.08);',
      '  background: #fff; box-shadow: 0 12px 24px rgba(18,18,18,.08);',
      '}',
      '.ig-sc-mega__body::before {',
      '  content: ""; position: absolute; top: -10px; left: 0; right: 0; height: 10px;',
      '}',
      '.ig-sc-mega__body.is-open { display: block; }',
      '.ig-sc-mega__inner {',
      '  position: relative; z-index: 6;',
      '  max-width: var(--page-width); margin: 0 auto;',
      '  padding: 2.4rem 5rem; box-sizing: border-box;',
      '}',
      '.ig-sc-mega__container { display: flex; align-items: flex-start; gap: 4rem; }',
      '.ig-sc-mega__cols { display: flex; gap: 5rem; flex-shrink: 0; }',
      '.ig-sc-mega__heading {',
      '  font-size: 1.1rem; font-weight: 600; letter-spacing: .12em;',
      '  text-transform: uppercase; color: rgba(18,18,18,.45);',
      '  margin: 0 0 1.4rem;',
      '}',
      '.ig-sc-mega__links { list-style: none; padding: 0; margin: 0; }',
      '.ig-sc-mega__link {',
      '  display: flex; align-items: center; gap: .8rem; padding: .55rem 0;',
      '  text-decoration: none; font-size: 1.5rem; line-height: 1.4; color: #121212;',
      '  transition: opacity .15s ease;',
      '}',
      '.ig-sc-mega__link:hover { opacity: .7; }',
      '.ig-sc-mega__badge {',
      '  display: inline-flex; align-items: center; padding: .25rem .7rem;',
      '  border-radius: 999px; background: #40631c; color: #fff;',
      '  font-size: 1rem; font-weight: 600; white-space: nowrap;',
      '}',
      '.ig-sc-mega__products { flex: 1; min-width: 0; }',
      '.ig-sc-mega__product-grid {',
      '  display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 1.2rem;',
      '}',
      '.ig-sc-mega__product-card {',
      '  display: flex; align-items: center; gap: 1rem; padding: 1rem 1.2rem;',
      '  border-radius: 1.2rem; background: rgba(18,18,18,.04);',
      '  text-decoration: none; color: #121212; transition: background .15s ease;',
      '}',
      '.ig-sc-mega__product-card:hover { background: rgba(18,18,18,.07); }',
      '.ig-sc-mega__product-image {',
      '  width: 5.6rem; height: 5.6rem; flex-shrink: 0;',
      '  border-radius: .8rem; overflow: hidden; background: #fff;',
      '}',
      '.ig-sc-mega__product-image img { width: 100%; height: 100%; object-fit: contain; display: block; }',
      '.ig-sc-mega__stars { display: inline-flex; align-items: center; gap: .1rem; }',
      '.ig-sc-mega__star { width: 1.4rem; height: 1.4rem; display: block; }',
      '.ig-sc-mega__star path { fill: #e0e0e0; }',
      '.ig-sc-mega__star--filled path { fill: #d4af37; }',
      '.ig-sc-mega__review-count { font-size: 1.2rem; color: rgba(18,18,18,.55); margin-left: .35rem; }',
      '.ig-sc-mega__rating { display: flex; align-items: center; gap: .1rem; margin-bottom: .25rem; }',
      '.ig-sc-mega__product-title {',
      '  margin: .3rem 0 0; font-size: 1.3rem; line-height: 1.35; font-weight: 500;',
      '  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;',
      '}',
      '@media (max-width: 1200px) {',
      '  .ig-sc-mega__container { gap: 2.5rem; }',
      '  .ig-sc-mega__cols { gap: 3rem; }',
      '}',
      '@media (max-width: 989px) {',
      '  .ig-sc-mega__body, .ig-sc-mega__backdrop { display: none !important; }',
      '  .ig-sc-mega__details .header__submenu {',
      '    display: block !important; visibility: visible !important; pointer-events: auto !important;',
      '  }',
      '}'
    ].join('\n');
  
  var productCache = Object.create(null);
  var initialized = false;
  var activeDetails = null;
  var closeTimer = null;

  function isMegaMenuEnabled() {
    var value = (document.body.getAttribute('data-ig-shop-mega-menu') || '').trim().toLowerCase();
    return value === 'true' || value === '1' || value === 'on' || value === 'yes';
  }
  
    function readConfig() {
      var el = document.getElementById('ig-sc-mega-menu-config');
      if (!el) return null;
  
      try {
        var data = JSON.parse(el.textContent);
        if (!data || !data.triggerLabel) return null;
  
        data.triggerLabels = [data.triggerLabel];
        data.desktopMinWidth = data.desktopMinWidth || 990;
        if (data.featured && data.featured.links && data.badgeLink && data.badgeText) {
          data.featured.links.forEach(function (link) {
            if (link.title === data.badgeLink) {
              link.badge = data.badgeText;
            }
          });
        }
  
        return data;
      } catch (e) {
        return null;
      }
    }
  
    function injectStyles() {
      if (document.getElementById('ig-sc-mega-menu-ab-styles')) return;
      var style = document.createElement('style');
      style.id = 'ig-sc-mega-menu-ab-styles';
      style.textContent = CSS;
      document.head.appendChild(style);
    }
  
    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }
  
    function handleFromUrl(url) {
      var match = String(url || '').match(/\/products\/([^/?#]+)/);
      return match ? match[1] : null;
    }
  
    function fetchProduct(handle) {
      if (!handle) return Promise.resolve(null);
      if (productCache[handle]) return productCache[handle];
  
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (res) {
          if (!res.ok) throw new Error('not found');
          return res.json();
        })
        .catch(function () {
          return null;
        });
  
      return productCache[handle];
    }
  
    function buildLinksColumn(heading, links) {
      if (!links || !links.length) return '';
  
      var items = links
        .map(function (link) {
          var badge = link.badge
            ? '<span class="ig-sc-mega__badge">' + escapeHtml(link.badge) + '</span>'
            : '';
          return (
            '<li><a class="ig-sc-mega__link" href="' +
            escapeHtml(link.url) +
            '"><span>' +
            escapeHtml(link.title) +
            '</span>' +
            badge +
            '</a></li>'
          );
        })
        .join('');
  
      return (
        '<div class="ig-sc-mega__col">' +
        '<p class="ig-sc-mega__heading">' +
        escapeHtml(heading) +
        '</p>' +
        '<ul class="ig-sc-mega__links" role="list">' +
        items +
        '</ul></div>'
      );
    }
  
    var STAR_PATH =
      'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z';
  
    function buildStarsHtml(rating) {
      var value = Math.max(0, Math.min(5, parseFloat(rating) || 0));
      var html = '<span class="ig-sc-mega__stars">';
  
      for (var i = 1; i <= 5; i++) {
        var fillAmount = Math.max(0, Math.min(1, value - (i - 1)));
        var filled = fillAmount >= 0.5;
        html +=
          '<svg class="ig-sc-mega__star' +
          (filled ? ' ig-sc-mega__star--filled' : '') +
          '" viewBox="0 0 24 24" aria-hidden="true">' +
          '<path d="' +
          STAR_PATH +
          '"></path></svg>';
      }
  
      html += '</span>';
      return html;
    }
  
    function buildRatingHtml(item) {
      var rating = parseFloat(item.rating) || 0;
      var reviewCount = parseInt(item.reviewCount, 10) || 0;
  
      if (rating <= 0 && reviewCount <= 0) return '';
  
      var countHtml =
        reviewCount > 0
          ? '<span class="ig-sc-mega__review-count">(' + escapeHtml(reviewCount) + ')</span>'
          : '';
  
      return (
        '<div class="ig-sc-mega__rating" aria-label="' +
        escapeHtml(rating) +
        ' out of 5 stars' +
        (reviewCount > 0 ? ', ' + escapeHtml(reviewCount) + ' reviews' : '') +
        '">' +
        buildStarsHtml(rating) +
        countHtml +
        '</div>'
      );
    }
  
    function buildProductCard(item, product) {
      var title = item.title || (product && product.title) || '';
      var url = item.url || (product && '/products/' + product.handle) || '#';
      var image = item.image || (product && product.featured_image) || '';
      var imageHtml = '<div class="ig-sc-mega__product-image"></div>';
  
      if (image) {
        imageHtml =
          '<div class="ig-sc-mega__product-image"><img src="' +
          escapeHtml(image) +
          '" alt="' +
          escapeHtml(title) +
          '" loading="lazy" width="112" height="112"></div>';
      }
  
      return (
        '<a class="ig-sc-mega__product-card" href="' +
        escapeHtml(url) +
        '">' +
        imageHtml +
        '<div class="ig-sc-mega__product-info">' +
        buildRatingHtml(item) +
        '<p class="ig-sc-mega__product-title">' +
        escapeHtml(title) +
        '</p></div></a>'
      );
    }
  
    function buildMegaBody() {
      var featured = CONFIG.featured || { heading: '', links: [] };
      var category = CONFIG.category || { heading: '', links: [] };
      var products = CONFIG.products || { heading: '', items: [] };
  
      var cols =
        buildLinksColumn(featured.heading, featured.links) +
        buildLinksColumn(category.heading, category.links);
  
      return (
        '<div class="ig-sc-mega__body">' +
        '<div class="ig-sc-mega__inner page-width">' +
        '<div class="ig-sc-mega__container">' +
        '<div class="ig-sc-mega__cols">' +
        cols +
        '</div>' +
        '<div class="ig-sc-mega__products">' +
        '<p class="ig-sc-mega__heading">' +
        escapeHtml(products.heading) +
        '</p>' +
        '<div class="ig-sc-mega__product-grid" data-ig-sc-mega-products></div>' +
        '</div></div></div></div>'
      );
    }
  
  function getMegaBody() {
      return document.querySelector('[data-ig-sc-mega-body]');
    }
  
    function getMegaBackdrop() {
      return document.querySelector('[data-ig-sc-mega-backdrop]');
    }
  
    function syncBackdropPosition() {
      var backdrop = getMegaBackdrop();
      var headerWrapper = document.querySelector('.header-wrapper');
      if (!backdrop || !headerWrapper) return;
      backdrop.style.top = headerWrapper.getBoundingClientRect().bottom + 'px';
    }
  
    function ensureBackdrop() {
      var existing = getMegaBackdrop();
      if (existing) return existing;
  
      var headerWrapper = document.querySelector('.header-wrapper');
      if (!headerWrapper) return null;
  
      var backdrop = document.createElement('div');
      backdrop.className = 'ig-sc-mega__backdrop';
      backdrop.setAttribute('data-ig-sc-mega-backdrop', '');
      backdrop.addEventListener('click', closeMegaMenu);
      backdrop.addEventListener('mouseenter', scheduleCloseMegaMenu);
      headerWrapper.appendChild(backdrop);
      syncBackdropPosition();
      return backdrop;
    }
  
    function openMegaMenu(details) {
      if (window.innerWidth < CONFIG.desktopMinWidth) return;
  
      clearTimeout(closeTimer);
  
      document.querySelectorAll('header-menu details[open], .header__inline-menu details[open]').forEach(function (el) {
        el.removeAttribute('open');
      });
  
      var body = getMegaBody();
      var backdrop = ensureBackdrop();
  
      details.removeAttribute('open');
      details.classList.add('is-active');
      if (body) body.classList.add('is-open');
      if (backdrop) {
        syncBackdropPosition();
        backdrop.classList.add('is-open');
      }
      activeDetails = details;
    }
  
    function closeMegaMenu() {
      clearTimeout(closeTimer);
  
      if (activeDetails) {
        activeDetails.removeAttribute('open');
        activeDetails.classList.remove('is-active');
        activeDetails = null;
      }
  
      var body = getMegaBody();
      var backdrop = getMegaBackdrop();
      if (body) body.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
    }
  
    function scheduleCloseMegaMenu() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeMegaMenu, 120);
    }
  
    function bindMenuInteractions(details) {
      var summary = details.querySelector('summary');
      var body = getMegaBody();
      var menuItem = details.closest('li');
  
      if (!summary || details.dataset.igScMegaBound) return;
      details.dataset.igScMegaBound = '1';
  
      details.removeAttribute('open');
  
      summary.addEventListener('click', function (event) {
        if (window.innerWidth < CONFIG.desktopMinWidth) return;
        event.preventDefault();
      });
  
      details.addEventListener('toggle', function () {
        if (window.innerWidth >= CONFIG.desktopMinWidth && details.hasAttribute('open')) {
          details.removeAttribute('open');
        }
      });
  
      function bindHover(el) {
        if (!el) return;
        el.addEventListener('mouseenter', function () {
          openMegaMenu(details);
        });
        el.addEventListener('mouseleave', scheduleCloseMegaMenu);
      }
  
      bindHover(summary);
      bindHover(menuItem);
      bindHover(body);
  
      if (!window.__igScMegaEscBound) {
        window.__igScMegaEscBound = true;
        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') closeMegaMenu();
        });
        window.addEventListener('resize', syncBackdropPosition);
        window.addEventListener('scroll', syncBackdropPosition, { passive: true });
      }
    }
  
    function populateProducts(details) {
      var grid = document.querySelector('[data-ig-sc-mega-products]');
      if (!grid || grid.dataset.igScMegaLoaded) return;
  
      var items = (CONFIG.products && CONFIG.products.items) || [];
      if (!items.length) return;
  
      grid.dataset.igScMegaLoaded = '1';
  
      Promise.all(
        items.map(function (item) {
          if (item.image) {
            return Promise.resolve(buildProductCard(item, null));
          }
  
          var handle = item.handle || handleFromUrl(item.url);
          return fetchProduct(handle).then(function (product) {
            return buildProductCard(item, product);
          });
        })
      ).then(function (cards) {
        grid.innerHTML = cards.join('');
      });
    }
  
    function normalizeLabel(str) {
      return String(str || '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ');
    }
  
    function getSummaryLabel(summary) {
      return normalizeLabel((summary.querySelector('span') || summary).textContent);
    }
  
    function findTriggerSummary() {
      var summaries = document.querySelectorAll(
        '.header__inline-menu summary.header__menu-item--main, ' +
          '.header__inline-menu summary.header__menu-item, ' +
          '.header__inline-menu summary.products-mega-menu'
      );
  
      var triggers = (CONFIG.triggerLabels || []).map(normalizeLabel).filter(Boolean);
      if (!triggers.length) return null;
  
      for (var i = 0; i < summaries.length; i++) {
        var summary = summaries[i];
        var label = getSummaryLabel(summary);
  
        for (var j = 0; j < triggers.length; j++) {
          if (label === triggers[j]) return summary;
        }
      }
  
      return null;
    }
  
    function mountMegaBody(details) {
      var headerWrapper = document.querySelector('.header-wrapper');
      var existingBody = document.querySelector('[data-ig-sc-mega-body]');
  
      if (!existingBody) {
        details.insertAdjacentHTML('beforeend', buildMegaBody());
        existingBody = details.querySelector('.ig-sc-mega__body');
        if (existingBody) {
          existingBody.setAttribute('data-ig-sc-mega-body', '');
        }
      }
  
      if (headerWrapper && existingBody && existingBody.parentElement !== headerWrapper) {
        headerWrapper.appendChild(existingBody);
      }
  
      return existingBody;
    }
  
  function teardownMegaMenu() {
    closeMegaMenu();

    document.querySelectorAll('.ig-sc-mega__details').forEach(function (details) {
      details.classList.remove('ig-sc-mega__details', 'is-active');
      details.removeAttribute('open');
      delete details.dataset.igScMegaBound;
    });

    var body = getMegaBody();
    if (body) body.remove();

    var backdrop = getMegaBackdrop();
    if (backdrop) backdrop.remove();

    initialized = false;
    activeDetails = null;
  }

  function transformMenu() {
    if (!isMegaMenuEnabled()) return false;
    if (initialized || window.innerWidth < CONFIG.desktopMinWidth) return false;
  
      var summary = findTriggerSummary();
      if (!summary) return false;
  
      var details = summary.closest('details');
      if (!details || details.classList.contains('ig-sc-mega__details')) return false;
  
      details.classList.add('ig-sc-mega__details');
      details.removeAttribute('open');
  
      mountMegaBody(details);
      ensureBackdrop();
      bindMenuInteractions(details);
      populateProducts(details);
  
      initialized = true;
      return true;
    }
  
  function attemptInit(attempts) {
    if (!isMegaMenuEnabled()) return;
    if (transformMenu()) return;
    if (attempts > 15) return;
    setTimeout(function () {
      attemptInit(attempts + 1);
    }, 300 + attempts * 200);
  }

  function syncMegaMenuState() {
    if (isMegaMenuEnabled()) {
      if (!initialized) attemptInit(0);
      return;
    }
    if (initialized) teardownMegaMenu();
  }

  injectStyles();

  window.IgShopMegaMenu = {
    isEnabled: isMegaMenuEnabled,
    enable: function () {
      document.body.setAttribute('data-ig-shop-mega-menu', 'true');
      syncMegaMenuState();
    },
    disable: function () {
      document.body.removeAttribute('data-ig-shop-mega-menu');
      syncMegaMenuState();
    },
    refresh: function () {
      if (!isMegaMenuEnabled()) return;
      teardownMegaMenu();
      attemptInit(0);
    }
  };

  function onReady() {
    syncMegaMenuState();
  }

  if (document.readyState === 'complete') {
    onReady();
  } else {
    window.addEventListener('load', onReady);
  }

  var domObserver = new MutationObserver(function () {
    if (isMegaMenuEnabled() && !initialized) attemptInit(0);
  });
  domObserver.observe(document.body, { childList: true, subtree: true });

  var attrObserver = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].attributeName === 'data-ig-shop-mega-menu') {
        syncMegaMenuState();
        break;
      }
    }
  });
  attrObserver.observe(document.body, { attributes: true, attributeFilter: ['data-ig-shop-mega-menu'] });

  window.addEventListener('resize', function () {
    if (!isMegaMenuEnabled()) return;
    if (window.innerWidth >= CONFIG.desktopMinWidth && !initialized) {
      attemptInit(0);
    }
    if (window.innerWidth < CONFIG.desktopMinWidth && initialized) {
      closeMegaMenu();
    }
  });
})();
  